import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useLayoutEffect, useState, useRef} from "react";
import {
    getClasses,
    getStudents,
    updateClasses,
    updateMainClass,
    updateMainClasses,
    updateStudents
} from "../../network/Endpoint";
import TopMenu from "../../components/TopMenu";
import ManagementNavigation from "./components/ManagementNavigation";
import StudentManagementPage from "./student/StudentManagementPage";
import ClassManagementPage from "./class/ClassManagementPage";
import NavigationLine from "../../assets/images/classes/line.svg"
import QRCodePage from "./loginQR/QRCodePage";
import StudentAccountLinkPage from "./studentAccountLink/StudentAccountLinkPage";
import SideMenu from "../../components/SideMenu";
import {cloneDeep} from "lodash";
import {fetchClassesSelector, classesState, savedClassesState, mainClassState} from "../../recoil/classes/classesState";
import {schoolNameState, teacherIdState, teacherNameState} from "../../recoil/teacher/teacherIdState";
import {useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState} from "recoil";
import {topMenuTypeState} from "../../recoil/menuState/topMenuState";

const ManagementPage = () => {
    const [searchParams] = useSearchParams();
    const [teacherId, setTeacherId] = useRecoilState(teacherIdState);


    const [savedClasses, setSavedClasses] = useRecoilState(savedClassesState);
    const [classes, setClasses] = useRecoilState(classesState); // classes atom 업데이트
    const classesLoadable = useRecoilValueLoadable(fetchClassesSelector);
    const [mainClass, setMainClass] = useRecoilState(mainClassState);
    const [teacherName, setTeacherName] = useRecoilState(teacherNameState);
    const [schoolName, setSchoolName] = useRecoilState(schoolNameState);


    const [students, setStudents] = useState(null);
    const [savedStudents, setSavedStudents] = useState(null);
    const [activeTab, setActiveTab] = useState("student");
    const [modifyCheck, setModifyCheck] = useState(null);
    const [isEditable, setIsEditable] = useState(false);

    const [isModStudentConsent, setIsModStudentConsent] = useState(false);

    const navigate = useNavigate();
    const setMenuType = useSetRecoilState(topMenuTypeState);

    // 중복 API 호출 방지를 위한 ref
    const prevMainClassIdRef = useRef(null);

    useEffect(() =>  {
        if(setMenuType){
            setMenuType("management");
        }
    },[setMenuType])


    useLayoutEffect(() => {
        const page = searchParams.get("page");
        if(page){
            setActiveTab(page);
        }
        const teacherIdParam = searchParams.get("teacherId");
        if (teacherIdParam) {
            setTeacherId(teacherIdParam);
        }
        if(!window.location.pathname.includes('/page')) {
            window.history.replaceState(null, "", "/management"); // 주소창에서 경로를 숨김
        }
    }, [searchParams, setTeacherId]);

    useEffect(() => {
        if (classesLoadable.state === "hasValue") {
            if(classesLoadable.contents){
                if(classes==null){
                    setClasses(cloneDeep(classesLoadable.contents.classes)); // classesState에 데이터 저장
                }
                setSavedClasses(cloneDeep(classesLoadable.contents.classes)); // 원본 데이터 저장
                setTeacherName(classesLoadable.contents?.teacherName || "");
                setSchoolName(classesLoadable.contents?.schoolName || "");

                const mainClassData = classesLoadable.contents.classes.find((item) => item.representativeClass === "Y");
                setMainClass(mainClassData || null);
            }else{
                alert('클래스를 생성해 주세요');
                navigate("/page/management?page=class");
            }
        }
    }, [classesLoadable]);

    const fetchGetStudents = async (classId) => {
        try {
            const body = {
                classId: classId
            };
            const res = await getStudents(body);

            const statusCode = res.data.status.code;
            const statusMessage = res.data.status.message;
            if (statusCode === 'Success') {
                const students = res.data.data.students;

                setStudents(cloneDeep(students));
                setSavedStudents(cloneDeep(students));
            } else {
                alert(`ERROR: 학생 정보 가져오는 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.\n${statusMessage}`);
            }
        } catch (error) {
            alert('학생 정보 가져오는 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.');
        }
    };
    const [updateClassesInfo, setUpdateClassesInfo] = useState([]);
    const [updatedClasses, setUpdatedClasses] = useState(null);

    const fetchUpdateClasses = async (isSetClasses) => {
        try {
            const request = {
                classes: updateClassesInfo
            }
            const body = {
                teacherId: teacherId,
                request: request
            };
            const res = await updateClasses(body);

            const statusCode = res.data.status.code;
            const statusMessage = res.data.status.message;
            if (statusCode === 'Success') {
                if(isSetClasses){
                    setClasses(cloneDeep(updatedClasses));
                    setSavedClasses(cloneDeep(updatedClasses));
                }
                setUpdateClassesInfo([]);
                setUpdatedClasses([]);
                setModifyCheck(true);
            } else {
                alert(`ERROR: 클래스 정보 수정 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.\n${statusMessage}`);
            }
        } catch (error) {
            alert('클래스 정보 수정 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.');
        }
    };

    const fetchUpdateMainClass = async() =>{
        try{
            const body = {
                teacherId: teacherId,
                classId: mainClass.classId
            };

            const res = await updateMainClass(body);

            const statusCode = res.data.status.code;
            const statusMessage = res.data.status.message;
            if (statusCode === 'Success') {

            } else {
                alert(`ERROR: 클래스 정보 수정 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.\n${statusMessage}`);
            }
        }catch (error){
            alert('클래스 정보 수정 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.');
        }
    }


    const [updateStudentInfo, setUpdateStudentInfo] = useState([]);
    const [updatedStudents, setUpdatedStudents] = useState(null);

    const fetchUpdateStudents = async (isSetStudent) => {
        try {
            const request = {
                students: updateStudentInfo
            }
            const body = {
                classId: mainClass.classId,
                request: request
            };
            const res = await updateStudents(body);

            const statusCode = res.data.status.code;
            const statusMessage = res.data.status.message;
            if (statusCode === 'Success') {
                if(isSetStudent){
                    setStudents(cloneDeep(updatedStudents));
                    setSavedStudents(cloneDeep(updatedStudents));
                }
                setUpdateStudentInfo([]);
                setUpdatedStudents([]);
                setModifyCheck(true);
            } else {
                alert(`ERROR: 학생 정보 수정 중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${statusMessage}`);
            }
        } catch (error) {
            alert('학생 정보 수정 중 오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    };


    useEffect( () => {
        if(mainClass && mainClass.classId !== prevMainClassIdRef.current){
            prevMainClassIdRef.current = mainClass.classId;
            fetchGetStudents(mainClass.classId);
            fetchUpdateMainClass();
        }
    }, [mainClass])



    useEffect(() => {
        if(modifyCheck){
            const notifyParent = () => {
                    setModifyCheck(false);
                    if (window.opener) {
                        window.opener.postMessage('reloadParent', process.env.REACT_APP_SCHOOL_WEB_URL);
                    }
            }

            // 창이 닫힐 때 알림
            window.addEventListener("beforeunload", notifyParent);

            return () => {
                window.removeEventListener("beforeunload", notifyParent);
            };
        }
    },[modifyCheck])


    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] min-h-screen">
            <div className="flex flex-col items-center justify-center  w-full">
                <ManagementNavigation
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    isEditable={isEditable}
                    setIsEditable={setIsEditable}
                    setClasses={setClasses}
                    savedClasses={savedClasses}
                    setStudents={setStudents}
                    savedStudents={savedStudents}
                    updateStudentInfo={updateStudentInfo}
                    setUpdateStudentInfo={setUpdateStudentInfo}
                    updateClassesInfo={updateClassesInfo}
                    setUpdateClassesInfo={setUpdateClassesInfo}
                    fetchUpdateStudents={fetchUpdateStudents}
                    fetchUpdateClasses={fetchUpdateClasses}
                    isModStudentConsent={isModStudentConsent}
                    setIsModStudentConsent={setIsModStudentConsent}
                />
                <div className="w-full flex justify-center items-center ">
                    <img
                        loading="lazy"
                        src={NavigationLine}
                        alt=""
                        className="mt-8  w-[1044px]"
                    />
                </div>
                {/* 조건부 렌더링 */}
                {activeTab === "class" && (
                    <>
                        <ClassManagementPage
                            teacherId={teacherId}
                            classes={classes}
                            setClasses={setClasses}
                            mainClass={mainClass}
                            setMainClass={setMainClass}
                            setModifyCheck={setModifyCheck}
                            isEditable={isEditable}
                            setIsEditable={setIsEditable}
                            fetchUpdateClasses={fetchUpdateClasses}
                            updateClassesInfo={updateClassesInfo}
                            setUpdateClassesInfo={setUpdateClassesInfo}
                            setUpdatedClasses={setUpdatedClasses}
                        />
                    </>
                )}
                {activeTab === "student" && (
                    <>
                        <StudentManagementPage
                            mainClass={mainClass}
                            setMainClass={setMainClass}
                            classes={classes}
                            setClasses={setClasses}
                            students={students}
                            setStudents={setStudents}
                            savedStudents={savedStudents}
                            teacherName={teacherName}
                            schoolName={schoolName}
                            setModifyCheck={setModifyCheck}
                            isEditable={isEditable}
                            setIsEditable={setIsEditable}
                            fetchUpdateStudents={fetchUpdateStudents}
                            updateStudentInfo={updateStudentInfo}
                            setUpdateStudentInfo={setUpdateStudentInfo}
                            updatedStudents={updatedStudents}
                            setUpdatedStudents={setUpdatedStudents}
                            isModStudentConsent={isModStudentConsent}
                            setIsModStudentConsent={setIsModStudentConsent}
                            fetchGetStudents={fetchGetStudents}
                        />
                    </>
                )}
                {activeTab === "qrCode" && (
                    <>
                        <QRCodePage
                            mainClass={mainClass}
                            setMainClass={setMainClass}
                            classes={classes}
                            setClasses={setClasses}
                            students={students}
                            setIsEditable={setIsEditable}
                            fetchUpdateStudents={fetchUpdateStudents}
                        />
                    </>
                )}
                {activeTab === "studentAccountLink" && (
                    <>
                        <StudentAccountLinkPage
                            mainClass={mainClass}
                            setMainClass={setMainClass}
                            classes={classes}
                            setClasses={setClasses}
                            teacherName={teacherName}
                            schoolName={schoolName}
                            fetchGetStudents={fetchGetStudents}
                        />
                    </>
                )}
            </div>

            <SideMenu></SideMenu>

        </div>
    )
}

export default ManagementPage;